
export const FormLayoutPropsDefaults = {
    visible: true,
    formStyle: {
      layout: 'vertical',
      labelAlign: 'left',
      size: 'middle',
      border: 'outlined',
      colon: false
    }
};
